export default "__VITE_ASSET__66uxH8kU__"